import { PickerBtn } from "@/comps/PickerBtn";
import { type RHFField } from "@/common/RHFWrapper";
import { openNumberInputModal } from "@/modal/openNumberInputModal";

interface RegionPickerProps extends RHFField {
  value?: string;
  onChange?: (value?: string) => void;
  label: string;
  classNames?: {
    wrapper?: string;
    content?: string;
    label?: string;
    value?: string;
    icon?: string;
  };
  prefix?: React.ReactNode;
  validator?: (value?: string) => Promise<void>;
}

export const NumberPicker = ({
  label,
  value,
  onChange,
  validator,
  prefix,
  ...props
}: RegionPickerProps) => {
  return (
    <PickerBtn
      label={label}
      value={
        value ? (
          <div className="flex items-center gap-x-1">
            {prefix}
            {value}
          </div>
        ) : undefined
      }
      onClick={async () => {
        const res = await openNumberInputModal({
          title: label,
          value,
          validator,
          prefix,
        });
        onChange?.(res.value);
      }}
      {...props}
    />
  );
};
